import { render, staticRenderFns } from "./LsLogo.vue?vue&type=template&id=4d559581&"
import script from "./LsLogo.vue?vue&type=script&lang=js&"
export * from "./LsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports